import { SERVER_TIME_DIFF_UPDATE } from "../actions/time";
import buildReducer from "./build-reducer";
import { Map } from "immutable";
let reducers = {};

reducers[SERVER_TIME_DIFF_UPDATE] = (state, action) => {
  return state.set("serverTimeDifference", action.serverTimeDifference);
};

export default buildReducer(Map({ serverTimeDifference: 0 }), reducers);
